<template>
  <div class="popup devicecheck ">
    <div class="popup__overlay" @click="closeModal"></div>
    <div class="popup__inner" :class="{'withData':data}">
      <div class="popup__inner__details" v-if="!data">

        <div class="devicecheck__popup  ">
          <div class="devicecheck__popup__image">

          </div>
          <div class="devicecheck__info">
            <span>
              CHECK IMEI NUMBER
            </span>
            <p>
              Every mobile phone, GSM modem or device with a built-in phone / modem has a unique 15 digit IMEI number.
              Based on this number, you can check some information about the device, eg brand or model.
            </p>
            <div>
              <div class="devicecheck__info__input " :class="{ 'error': $v.imei.$error,'valid':!$v.imei.$invalid }">
                <span class="devicecheck__info__error">{{ errorMsg}}</span>
                <div class="error-tooltip__wrap">
                  <!-- <h4 class="menu-link up-text error-tooltip__content">Invalid Imei</h4> -->
                  <p class="description">Please, fill out this field</p>
                </div>

                <input v-model="imei" type="text" placeholder="Enter IMEI e.g. 123456789012347"
                  :class="{valid:(imei.length>0)}">
                <button v-show="!loading" @click="submit()">Check</button>
                <button v-show="loading">
                  <div class="loadingio-spinner-rolling-bc7bh7dtoj">
                    <div class="ldio-w5zi4kwt34">
                      <div></div>
                    </div>
                  </div>
                </button>
                <div class="recaptcha">
                  <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                    @render="onCaptchaRendered" size="checkbox" theme="dark" :sitekey="this.sitekey">
                  </vue-recaptcha>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      <div>

      </div>
      <div class="imei_speci " v-if="data">
        <div class="imei_speci__title">
          {{data.marketingname}}
        </div>
        <div class="row ">
          <div class="col-md-4 col-xs-6">
            <div class="imei_speci__item imei_price rainbow">
              <div class="imei_spaci_item_box">
                <div class="imei_speci__item__title">
                  Current Price
                </div>
                <div class="imei_speci__item__value">
                  {{data.pricingEngine.currentAverage}}
                </div>
              </div>
            </div>
          </div>
            <div class="col-md-4 col-xs-6">
              <div class="imei_speci__item ">
                <div class="imei_spaci_item_box">
                  <div class="imei_speci__item__title">
                    Brand Name
                  </div>
                  <div class="imei_speci__item__value">
                    {{data.brandname}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-6">
              <div class="imei_speci__item">
                <div class="imei_spaci_item_box">
                  <div class="imei_speci__item__title">
                    Operating system
                  </div>
                  <div class="imei_speci__item__value">
                    {{data.operatingsys}}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-4 col-xs-6">
            <div class="imei_speci__item">
              <div class="imei_spaci_item_box">
              <div class="imei_speci__item__title">
                Marketing Name
              </div>
              <div class="imei_speci__item__value">
                {{data.marketingname}}
              </div>
              </div>
            </div>
          </div> -->
            <div class="col-md-4 col-xs-6">
              <div class="imei_speci__item">
                <div class="imei_spaci_item_box">
                  <div class="imei_speci__item__title">
                    Branch
                  </div>
                  <div class="imei_speci__item__value">
                    {{data.branchid}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-6">
              <div class="imei_speci__item">
                <div class="imei_spaci_item_box">
                  <div class="imei_speci__item__title">
                    Manu facturer
                  </div>
                  <div class="imei_speci__item__value">
                    {{data.manufacturer}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-6">
              <div class="imei_speci__item">
                <div class="imei_spaci_item_box">
                  <div class="imei_speci__item__title">
                    Model Name
                  </div>
                  <div class="imei_speci__item__value">
                    {{data.modelname}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-6">
            </div>
          </div>

          <br>
          <br>
          <h2> More Information about {{data.marketingname}}: </h2>
          <div class="imei_chek">

            <div class="row" v-for="(item,key) in data">
              <div class="col-xs-6 imei_chek__title">{{ key }}</div>
              <div class="col-xs-6 imei_chek__value">
                <div v-if="key=='pricingEngine'">
                  <div v-for="(pe,peKey) in item">
                    <div class="pricingEngine__item row">
                      <div class="col-xs-12 pricingEngine__item__title">
                        {{peKey}}
                      </div>
                      <div class="col-xs-12 pricingEngine__item__value">
                        {{pe}}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="key=='band'" class="pricingEngine__item__band">
                  {{ item }}
                </div>
                <div v-else>
                  {{ item }}
                </div>

              </div>
            </div>


          </div>
          <div class="popup__footer">

          </div>


        </div>
        <div class="popup__inner__close" @click="closeModal()">
          <i class="popup__inner__close__icon"></i>
        </div>

      </div>
    </div>
</template>

<script>
  import {
    required,
    minLength,
  } from 'vuelidate/lib/validators';
  import axios from 'axios';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'check-devices',
    data() {
      return {
        sitekey: "6LeKEokaAAAAANt--Lbr__JFA9Dcmm0ncQ0lEMLc",
        widgetId: '',
        recaptchaStatus: false,
        isActive: undefined,
        loading: false,
        submitStatus: true,
        selectedCupId: undefined,
        isOpen: false,
        apply: false,
        imei: '',
        errorMsg: '',
        data: undefined,}
        // data: {
        //   "refcode": "24022022194611",
        //   "responsestatus": "success",
        //   "deviceid": "358815108075473",
        //   "partnerid": "Acme",
        //   "branchid": "USA",
        //   "recordidentifier": "100",
        //   "blackliststatus": "No",
        //   "greyliststatus": "No",
        //   "manufacturer": "Samsung Korea",
        //   "brandname": "Samsung",
        //   "marketingname": "Galaxy S10+",
        //   "modelname": "SM-G975F/DS",
        //   "band": "CA_2,CA_3,CA_7,CA_38,CA_40,CA_41,CA_1C,CA_2C,CA_3C,CA_38C,CA_40C,CA_40D,CA_41C,CA_41D,CA_66B,CA_66C,CA_1A-3A,CA_1A-3A-3A,CA_1A-5A,CA_1A-7A,CA_1A-8A,CA_1A-20A,CA_1A-28A,CA_1A-40A,CA_1A-41A,CA_2A-4A,CA_2A-5A,CA_2A-7A,CA_2A-7A-7A,CA_2A-12A,CA_2A-13A,CA_2A-17A,CA_2A-28A,CA_2A-66A,CA_3A-5A,CA_3C-5A,CA_3A-7A,CA_3A-3A-7A,CA_3A-7A-7A,CA_3A-7C,CA_3C-7A,CA_3C-7C,CA_3A-8A,CA_3A-3A-8A,CA_3C-8A,CA_3C-20A,CA_3A-28A,CA_3A-32A,CA_3A-38A,CA_3A-40A,CA_3A-40C,CA_3A-41A,CA_4A-5A,CA_4A-7A,CA_4A-12A,CA_4A-4A-12A,CA_4A-13A,CA_4A-17A,CA_4A-28A,CA_5A-7A,CA_5A-40A,CA_7A-8A,CA_7A-20A,CA_7A-28A,CA_7C-28A,CA_8A-40A,CA_12A-66A,CA_12A-66A-66A,CA_20A-32A,CA_20A-38A,CA_20A-38C,CA_38A-40A,CA_2A-2A,CA_3A-3A,CA_4A-4A,CA_7A-7A,CA_40A-40A,CA_41A-41A,CA_41A-41C,CA_1A-3A-5A,CA_1A-3A-7A,CA_1A-3C-7A,CA_1A-3A-8A,CA_1A-3A-20A,CA_1A-3A-28A,CA_1A-3A-41A,CA_1A-5A-7A,CA_1A-7A-8A,CA_1A-7A-20A,CA_1A-7A-28A,CA_2A-4A-5A,CA_2A-4A-7A,CA_3A-5A-40A,CA_3A-7A-8A,CA_3A-7A-20A,CA_3A-7A-28A,CA_3A-7A-32A,CA_3A-20A-32A,CA_1A-3A-7A-20A,CA_3A-7A-20A-32A,LTE FDD BAND 1,LTE FDD BAND 2,LTE FDD BAND 3,LTE FDD BAND 4,LTE FDD BAND 5,LTE FDD BAND 7,LTE FDD BAND 8,LTE FDD BAND 12,LTE FDD BAND 13,LTE FDD BAND 17,LTE FDD BAND 18,LTE FDD BAND 19,LTE FDD BAND 20,LTE FDD BAND 25,LTE FDD Band 32,LTE FDD BAND 26,LTE FDD BAND 28,LTE FDD Band 66,LTE TDD BAND 38,LTE TDD BAND 39,LTE TDD BAND 40,LTE TDD BAND 41,GSM 1800,GSM 1900,GSM850 (GSM800),GSM 900,WCDMA FDD Band 1,WCDMA FDD Band 2,WCDMA FDD Band 4,WCDMA FDD Band 5,WCDMA FDD Band 8,WCDMA TDD Band A,WCDMA TDD Band F",
        //   "operatingsys": "Android",
        //   "nfc": "Yes",
        //   "bluetooth": "Yes",
        //   "wlan": "Yes",
        //   "devicetype": "Smartphone",
        //   "error": null,
        //   "pricingEngine": {
        //     "confidence": "Excellent",
        //     "referenceId": "6fae2aee-38bd-4dcc-b974-55f0ccc9c7f8",
        //     "name": "Galaxy S10: 128GB",
        //     "open": 0.0,
        //     "close": 263.4,
        //     "highest": 263.41,
        //     "lowest": 263.09,
        //     "currentAverage": 263.4,
        //     "gradeAverage": ["234.43", "205.45", "176.48"],
        //     "ratio": 0.0,
        //     "brandName": "SAMSUNG",
        //     "categoryName": "Phone",
        //     "productName": "Galaxy S10"
        //   }
        // }
      // }

    },

    validations: {
      imei: {
        required,
        minLength: minLength(8)
      },
    },
    props: {
      pakketData: {},
    },
    created() {
      // this.selectedCupId = this.selectedCupId || this.pakketData.content[0].id;
    },
    methods: {
      renameKeys(obj, newKeys) {
        const keyValues = Object.keys(obj).map(key => {
          const newKey = newKeys[key] || key;
          return {
            [newKey]: obj[key]
          };
        });
        return Object.assign({}, ...keyValues);
      },
      closeModal() {
        // EventBus.$emit('close-modal', undefined);
        console.log("closeModal");
        this.$parent.closeCheckDevicePopup();
        this.$destroy();
      },
      submit() {
        this.$v.$touch();
        this.loading = true;
        if (this.$v.$invalid || !this.recaptchaStatus) {
          this.loading = false;

          this.submitStatus = false;
        } else {
          var $this = this;
          var imeival = this.imei;
          axios.get("https://superapi.mobilityintel.com/api/DeviceCheck?deviceid=" + imeival).then(response => {


            $this.data = response.data;
            delete $this.data.pricingEngine.confidence;
            delete $this.data.pricingEngine.referenceId;
            delete $this.data.pricingEngine.open;
            delete $this.data.pricingEngine.close;
            delete $this.data.pricingEngine.highest;
            delete $this.data.pricingEngine.lowest;
            delete $this.data.pricingEngine.gradeAverage;
            $this.data.pricingEngine.currentPrice = $this.data.pricingEngine.currentAverage
            delete this.data.pricingEngine.currentAverage

          }).catch(function (error) {
            if (error.response) {
              console.log('error.response');
              $this.errorMsg = error.response.data.errors[0].problem;
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data.errors);

            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log('error.request', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });;
        }



      },

      setToken: function (token) {
        this.form['g-recaptcha-response'] = token;
      },
      onCaptchaVerified: function (token) {
        this.recaptchaStatus = true;
      },
      onCaptchaExpired: function () {
        this.setToken('');
      },
      onCaptchaRendered: function (id) {
        this.widgetId = id;
      },
    },
    mounted() {

    },
    components: {
      VueRecaptcha
    }

  }

</script>

<style lang="scss" scoped>
  @import './style.scss';

</style>



// WEBPACK FOOTER //
// src/components/CheckDevice/index.vue